import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import heroHomepage from 'Templates/blocks/heroHomepage/heroHomepage.vue';

export default function herohomepage() {
  try {
    // Get hero block
    const options = document.querySelector('.hero-homepage');
    if (options) {
      // Hero blocks are enqueued and rendered immediately. No need to load it via import.
      const mountElement = options.children[0];
      // Guard against double-initialisation (lazyloader + direct call)
      if (mountElement && mountElement.__vue__) {
        return;
      }
      Vue.use(Vue2TouchEvents);
      new Vue({
        name: 'HeroHomepage',
        data: { ...mountElement.dataset, options },
        render: (h) => h(heroHomepage)
      }).$mount(mountElement);
    } else {
      // eslint-disable-next-line no-console
      console.warn('No hero homepage block');
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
